// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-container {
  position: relative;
  width: 100%;
  max-width: 375px;
}

.multi-select-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 38px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.multi-select-input:hover {
  border-color: #aaa;
}

.multi-select-input.open {
  border-color: #4a90e2;
  box-shadow: 0 0 0 1px #4a90e2;
}

.selected-options {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex: 1;
}

.selected-option-badge {
  display: inline-flex;
  align-items: center;
  background-color: #e8f0fe;
  color: #1a73e8;
  border-radius: 16px;
  padding: 2px 8px;
  margin: 2px;
  font-size: 14px;
}

.remove-option {
  background: none;
  border: none;
  color: #5f6368;
  margin-left: 4px;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
}

.remove-option:hover {
  color: #d93025;
}

.placeholder {
  color: #757575;
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 10px;
  color: #5f6368;
  margin-left: 8px;
}

.options-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 300px;
  margin-top: 5px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.search-container {
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.search-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.options-list {
  overflow-y: auto;
  max-height: 240px;
}

.option {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
}

.option:hover {
  background-color: #f5f5f5;
}

.option.selected {
  background-color: #f0f7ff;
}

.option input[type=checkbox] {
  margin-right: 8px;
}

.no-options {
  padding: 12px;
  text-align: center;
  color: #757575;
}/*# sourceMappingURL=MultiSelect.css.map */`, "",{"version":3,"sources":["webpack://./src/components/MultiSelect/MultiSelect.scss","webpack://./src/components/MultiSelect/MultiSelect.css"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;ACCJ;;ADEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;ACCJ;;ADEE;EACE,kBAAA;ACCJ;;ADEE;EACE,qBAAA;EACA,6BAAA;ACCJ;;ADEE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;ACCJ;;ADEE;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;ACCJ;;ADEE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;ACCJ;;ADEE;EACE,cAAA;ACCJ;;ADEE;EACE,cAAA;EACA,eAAA;ACCJ;;ADEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;ACCJ;;ADEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;ACCJ;;ADEE;EACE,YAAA;EACA,6BAAA;ACCJ;;ADEE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;ACCJ;;ADEE;EACE,gBAAA;EACA,iBAAA;ACCJ;;ADEE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;ACCJ;;ADEE;EACE,yBAAA;ACCJ;;ADEE;EACE,yBAAA;ACCJ;;ADEE;EACE,iBAAA;ACCJ;;ADEE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;ACCJ,CAAA,0CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
